import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LocalizedStrings from 'react-localization';
import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import { SetComponentLanguage } from '../../../helpers';
import en from './locales/en.json';
import fr from './locales/fr.json';
import './StreamCodeModal.css';

const strings = SetComponentLanguage(LocalizedStrings, en, fr);

class StreamCodeModal extends Component {
	constructor(props) {
		super(props);
		this.state = {
			streamId: null
		};
	}

	toggle = () => {
		this.props.toggleCodeModal();
	}

	handleChange = (event) => {
		this.setState({streamId: event.target.value});
	}

	render() { 
		return ( 
			<div>
		  		<Modal isOpen={this.props.isCodeModalOpen} className="modal-stream-code">
		          	<ModalHeader>{strings.title}</ModalHeader>
		          	<ModalBody>
						<div>
							<ul className="modal-stream-code__text">
								<li>{strings.bullet1}</li>
								<li>{strings.bullet2}</li>
								<li>{strings.bullet3}</li>
								<li>{strings.bullet4}</li>
							</ul>
							<p>{strings.paragraph}</p>
							<h4>{strings.title2}</h4>
						</div>

						<div className="showtix-form__group pt-2">
							<div className="showtix-form__input">
								<input
									type="text"
									className="showtix-input"
									id="streamId"
									name="streamId"
									value={this.state.streamId}
									onChange={this.handleChange}
									onKeyDown={e => {
										if (e.keyCode === 13) {
											this.props.saveStreamCode(this.state.streamId.toLowerCase());
											e.preventDefault();
											e.stopPropagation();
										}
									}}
								/>
							</div>
						</div>
		          	</ModalBody>
		          	<ModalFooter className="text-center">
						<button 
						  	type="button" 
							className="showtix-button showtix-background__primary-1"
							onClick={() => this.props.saveStreamCode(this.state.streamId.toLowerCase())}
						>
							<span>{strings.saveClose}</span>
						</button>
		          	</ModalFooter>
		        </Modal>
			</div>
		)
	}
}

StreamCodeModal.propTypes = {
	isCodeModalOpen: PropTypes.bool,
	toggleCodeModal: PropTypes.func,
	saveStreamCode: PropTypes.func
}
 
export default StreamCodeModal;


// WEBPACK FOOTER //
// ./src/components/Stream/StreamCodeModal/StreamCodeModal.js